/**
 * Generic Dashlet with a 'FORM' inside
 */
hrd.AbstractFormDashlet = hrd.AbstractDashlet.extend({
	init: function(panel, options){
		var defaults = {
			impl: 'hrd.AbstractFormDashlet',
			labelsOnTop: false,
			decorate: false,
			showEditableMarker: false,
			selectable: false
		};
		this._super(panel, $.extend({}, defaults, options));
	},
	doInit: function(){
		this._super();
		$.when(this.beforeDoForm()).then(() => this.doForm());
	},
	beforeDoForm: $.noop,
	doForm: function(){
		var options = this.formSettings() || {};
		var arrangeFieldSet = (this.settings.arrangeFieldSet == undefined) ? {extraWidth: 3} : this.settings.arrangeFieldSet;
		if(this.settings.size === '2x'){
			arrangeFieldSet.size = '2x';
		}
		var formSettings = $.extend(true, {}, {
			reference: this,
			arrangeFieldSet: arrangeFieldSet,
			labelsOnTop: this.settings.labelsOnTop || false,
			buttonStyles: this.settings.buttonStyles || 'squared',
			selectable: this.settings.selectable,
			usedIn: 'dashlet'
		}, options);

		/**
		 * @type {hrd.Form}
		 * */
		this.formInstance = new hrd.Form(this.CONTENT_ID, formSettings);

		var deferred = $.Deferred();
		if(this.isInsideNotActiveTab()){
			if(this.isFirstTab()){
			// potrebbe essere una dashlet in un nested tab di un tab invisibile, ma solo se è il primo dei tab...
			var parentsTab = $(this.CONTENT_ID).parents('.dashlet-tab-pane');
			if(parentsTab.length > 1){
					parentsTab.on('tab-activated', (evt, data) => {
						deferred.resolve();
					});
				} else {
					// it is the first tab, not inside parent tab, but still hidden
					// need to be activated when tab is shown (can use 'one' because needed only once)
					$(this.TAB_ID).one('tab-shown', (evt, data) => {
						deferred.resolve();
					});
				}
			}

			// should be enhanced only when tab is activated first time
			this.getContainerTab().on('tab-activated', (evt, data) => {
				deferred.resolve();
			});
		} else {
			deferred.resolve();
		}
		deferred.then(() => {
			if(!$(this.HEADER_ID).is(':visible')){
				var myParentIsTab = $(this.PANEL_ID).parent().hasClass('dashlet-tab-pane');
				var cls = (!myParentIsTab) ? 'ui-corner-top' : 'ui-corner-tr';
				$('fieldset', this.CONTENT_ID).addClass(cls);
			}
			this.formInstance.enhance().then(() => {
				this.formEnhanced();
				// si dovrebbe riattivare la toform mancante
				if(this.formInstance.toBeExecutedWith != undefined){
					this.formInstance.toForm(); // viene attivata coi campi memorizzati....
				}
				if(this.settings.decorate == true){
					this.formInstance.decorateForm();
				}
				if(typeof this.mixinFormEnhanced == 'function') {
					this.mixinFormEnhanced(this.formInstance);
				}
			});
		});
	},
	doResize: function(redraw){
		this.formInstance.arrangeFieldSet();
		this.formInstance.resizeForm();
	},
	formSettings: $.noop,
	formEnhanced: $.noop,
	enhanceAgain: function(){
		this.formInstance.enhanceAgain().then(() => {
			this.formEnhanced(true);
			if(this.settings.decorate == true){
				this.formInstance.decorateForm();
			}
		});
	},
	enhanceBlock: function(selector) {
		return this.formInstance.enhanceBlock(selector);
	},
	enableButton: function($btn, endWaiting){
		$btn = this.formInstance.getField($btn);
		if($btn.exists()){
			$btn.button('enable');
			if(endWaiting === true){
				$btn.waiting('done');
			}
		}
	},
	disableButton: function($btn, startWaiting){
		$btn = this.formInstance.getField($btn);
		if($btn.exists()){
			$btn.button('disable');
			if(startWaiting === true){
				$btn.waiting();
			}
		}
	},
	isButtonEnabled: function($btn){
		$btn = this.formInstance.getField($btn);

		return $btn.exists() && !$btn.button('option', 'disabled');
	},
	get: function(property, object, defaultValue){
		object = object || this.formInstance.toObject();
		var v = this.formInstance.getValueByPath(object, property);
		return (v == undefined) ? defaultValue : v;
	},
	addEditedIcon: function() {
		if($(this.HEADER_ID).is(':visible')) {
			var $headerTitle = $(this.HEADER_ID).find('.ui-panel-title-text');
			if($headerTitle.exists()) {
				const $editedIcon = $('.title-icon', this.HEADER_ID);

				if(!$editedIcon.exists()) {
					$headerTitle.before('<i class="title-icon f-icon fas fa-pencil-alt"></i>');
				}
			}
		} else if(this.isInsideTab()) {
			var tab = this.dashboard.getTabById(this.TAB_ID);
			if(tab.exists()) {
				tab.append('<i class="title-icon f-icon fas fa-pencil-alt"></i>');
			}
		}
	},
	removeEditedIcon: function(){
		if($(this.HEADER_ID).is(':visible')){
			$('.title-icon', $(this.HEADER_ID)).remove();
		} else if(this.isInsideTab()){
			var tab = this.dashboard.getTabById(this.TAB_ID);
			$('.title-icon', tab).remove();
		}
	},
	markAsEdited: function(show){
		show = show == undefined ? true : !!show;
		if(this.settings.showEditableMarker){
			if(show){
				this.addEditedIcon();
			} else {
				this.removeEditedIcon();
			}
		}
	},
	changeFieldLabel: function(field, label){
		this.formInstance.changeFieldLabel(field, label);
	},
	/**
	 * Generic action method for resetting current form
	 */
	resetFormAction: function(event, formData, formInstance) {
		this.formInstance.resetForm();
		this.formInstance.initForm();
	},
	/**
	 * Shortcut to get tableManager for a table-like field
	 */
	getTableManager: function(field) {
		return this.formInstance.getTableManager(field);
	},
	getTableId: function(field) {
		return this.formInstance.getTableId(field);
	},
});
